export default __webpack_public_path__ + "static/media/earth1.5f30e14f.jpg";